import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {AnimatedSprite} from "./AnimatedSprite";

// Constructor
export class Tree extends AnimatedSprite {

  constructor(x, y, asset, appearingScreenPercent, game) {
    super(x, y, asset, appearingScreenPercent, game);
  }

  buildAnimations() {
    // No animation for now
    // If you do not have a inAnimation, make sure you set the appearingScreenPercent
    // at 1 so it will not pop out of nowhere
  }

}
